/*
 * Smooth-scroll delegato per l'indice (01-05) della pagina Our Method.
 * Delega a livello document: un click su qualsiasi [data-scroll-to] scrolla
 * verso l'elemento con quell'id. Robusto anche nel theme editor (delegazione,
 * nessuna dipendenza da document.currentScript o da un wrapper specifico).
 */
(function () {
  if (window.__anScrollToBound) return;
  window.__anScrollToBound = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-scroll-to]');
    if (!btn) return;
    var id = btn.getAttribute('data-scroll-to');
    if (!id) return;
    var el = document.getElementById(id);
    if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });
})();
